module.exports = __webpack_public_path__ + "media/ambience.e1b15d82.mp3";